import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { appUrlForPath } from '../../utils/siteHost';
import { LoadingSpinner } from '../common';

interface RedirectToAppHostProps {
  /** Defaults to current pathname + search */
  path?: string;
}

/**
 * Full navigation to the app subdomain (marketing host must not run the app shell).
 */
export function RedirectToAppHost({ path }: RedirectToAppHostProps) {
  const location = useLocation();
  const targetPath =
    path ?? `${location.pathname}${location.search}${location.hash}`;

  useEffect(() => {
    window.location.replace(appUrlForPath(targetPath));
  }, [targetPath]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--se-porcelain)]">
      <LoadingSpinner size="lg" />
      <span className="sr-only">Redirecting to Strat-Edu app</span>
    </div>
  );
}
